<script>
    import {pop} from 'svelte-spa-router';
    import ModelForm from '../Forms/ModelForm.svelte';

    export let params;
    const object_type = "assessment";
    const returnURL = '#/assessments/'

    const goBack = () => pop();
</script>

<ModelForm {params} {object_type} {returnURL} on:save={goBack} on:delete={goBack} />